<template>
  <v-app>
    <v-main>
      <v-container>
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>{{ $t('alertas.nuevosocio') }}</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-row  v-if="conectado" justify="center">
          <v-col  cols="12" sm="12" lg="9" md="9">

            <v-alert
                :value="alertnoacepto"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
             Tienes que Aceptar las Condiciones
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Tu solicitud fue creada con éxito
            </v-alert>
            <section id="main-cabecera" class="mb-4">
              <v-row align="center" class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 v-if="logoexist" class="display-1 font-weight-bold">
                    <v-img width="150" :src="logoimg" />
                  </h1>
                  <h1 v-else>{{titulonegocio}}</h1>
                </v-col>
              </v-row>
              <v-row  justify="space-between">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-form ref="form">
                    <v-row>
                      <v-col  cols="6" sm="6" md="4">
                        <v-autocomplete
                            v-model="editedItem.socioPrincipal.tipoDocumento"
                                         :items="tiposdoc"
                                         item-text="tipoDocumento"
                                         return-object
                                         label="Tipo de Documento">

                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.dni" label="Numero de Documento" required></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.email" :label="$t('formularios.Email')" disabled></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.nombre" :label="$t('formularios.nombres')"></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.apellidoPaterno" :label="$t('formularios.ApPaterno')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campoapmaterno" cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.apellidoMaterno" :label="$t('formularios.ApMaterno')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campotelefono" cols="6" sm="6" md="4">
                        <v-text-field type="number" v-model="editedItem.socioPrincipal.telefono" :label="$t('formularios.Telefono')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campodireccion" cols="6" sm="6" md="4">
                        <v-text-field  v-model="editedItem.socioPrincipal.direccion" :label="$t('formularios.Direccion')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campodistrito" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.distrito.ciudad.provincia.pais" :items="paises"  item-text="pais" persistent-hint
                                         return-object
                                         @change="cambiopais"

                                         label="Pais de Direccion"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campodistrito" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.distrito.ciudad.provincia" :items="provincias"  item-text="provincia" persistent-hint
                                         return-object
                                         @change="cambioprovincia"

                                         label="Departamento"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campodistrito" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.distrito.ciudad" :items="ciudades"  item-text="ciudad" persistent-hint
                                         return-object
                                         @change="cambiociudad"
                                         label="Provincia"
                        ></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campodistrito" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.distrito" :items="distritos"  item-text="distrito" persistent-hint
                                         return-object
                                          :label="$t('formularios.EscogerDistrito')"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.camposexo" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.sexo" :items="sexos"  item-text="sexo"  persistent-hint
                                         return-object
                                          label="Escoger Sexo"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campofecnac" cols="6" sm="6" md="4">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.socioPrincipal.fechaNacimiento"
                                :label="$t('formularios.FechaNacimiento')"
                                readonly
                                @blur="date = editedItem.socioPrincipal.fechaNacimiento"
                                v-on="on"
                                v-bind="attrs"
                                prepend-icon="fas fa-calendar"
                            ></v-text-field></template>
                          <v-date-picker
                              v-model="date"
                              :active-picker.sync="activePicker"
                              min="1950-01-01"
                              locale="es-es"
                              :max="fechamax"
                              @change="editedItem.socioPrincipal.fechaNacimiento = date"
                              @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col v-if="negociodisenio.campotipocarnet" cols="6" sm="6" md="6">
                        <v-autocomplete
                            v-model="editedItem.tipoCarnetSocio"
                            :items="tiposcarnets"
                            item-text="tipoCarnet"
                            :hint="$t('formularios.TipoCarnet')" persistent-hint
                                         return-object
                                          :label="$t('formularios.EscogerTipoCar')"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.camporeferido" cols="6" sm="6" md="4">
                        <v-text-field  v-model="editedItem.referido" :label="$t('formularios.Referido')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campocontacto" cols="6" sm="6" md="4">
                        <v-autocomplete
                            v-model="editedItem.contacto"
                            :items="Contactos"
                            item-text="contacto"
                            hint="Elija un Contacto" persistent-hint
                            return-object
                            label="Contacto"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campofumador" cols="12" sm="12" md="4">
                        <v-radio-group
                            v-model="editedItem.personaSocioDTO.personaFumador"
                            :label="$t('formularios.Fumas')"
                            row
                            mandatory
                        >
                          <v-radio
                              :label="$t('formularios.Si')"
                              value="true"
                          ></v-radio>
                          <v-radio
                              :label="$t('formularios.No')"
                              value="false"
                          ></v-radio></v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-row>
                          <v-col v-if="hayimagen" md="12" lg="12" cols="12">

                            <v-img :src="imagen2" height="300px" aspect-ratio="1.7" />
                          </v-col>
                          <v-col md="12" lg="12" cols="12">
                            <v-file-input
                                label="Subir Archivo"
                                accept="image/*"
                                filled
                                chips
                                v-model="imagen"
                                @change="onFileChange"
                                prepend-icon="mdi-camera"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">

                        <v-checkbox
                            v-model="editedItem.aceptoCondicion"
                            :rules="[v => !!v || 'Debes aceptar para continuar']"
                            :label="negociodisenio.condiciones"
                            required
                        ></v-checkbox>  </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn v-bind:style="btnPag" v-model="boton"  @click="save">Grabar</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </section>
          </v-col>
        </v-row>

        <v-row v-else justify="center" align="center">
          <v-col cols="12" lg="9" md="10">
          <v-card>
            <v-card-title>
              Inscripción a {{negocio.negocio}}
            </v-card-title>
            <v-card-subtitle>
              <v-img :src="negocio.logo270" height="150px" contain></v-img>
            </v-card-subtitle>
            <v-card-text >
              <div >

                  <v-row justify="center" align="center">
                    <v-col v-if="normal" lg="8" md="6" cols="12" sm="6">
                      <p>Registrarte o Conectarte si ya tienes una cuenta con nosotros.</p>
                      <p v-if="browser">Puedes ingresar directamente con Google o Apple</p>
                      <p v-else>Ingresaste por un browser interno de Instagram o algún otra app, para ingresar con Google o Apple te recomendamos abrir Chrome o Safari</p>

                      <v-row v-if="browser" justify="center" align="center">
                        <v-col cols="10" lg="5" md="5">
                          <v-btn rounded width="100%" style="background: #4F86EC;" @click="signingoogle">
                            <v-icon>fab fa-google</v-icon> &nbsp;Ingresa con Google
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-if="browser" justify="center" align="center">
                        <v-col cols="10" lg="5" md="5">
                          <v-btn rounded width="100%" style="background: #E0E5FA; color: black;" @click="signinapple">
                            <v-icon>fab fa-apple</v-icon> &nbsp;Ingresa con Apple
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="5" md="5">
                          <v-btn rounded width="100%" style="background: #FFFFFF; color: black;" @click="signinemail">
                            <v-icon>fas fa-envelope</v-icon> &nbsp;Ingresa con Email
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="5" md="3">
                          ¿Eres nuevo?
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="5" md="3">
                          <v-btn rounded width="100%" style="background: cornflowerblue; color: black;" @click="registeremail">
                            <v-icon>fas fa-envelope</v-icon> &nbsp;Registrate con Email
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="login" lg="8" md="6" cols="12" sm="6">
                      <v-row>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <h2>Conectarse</h2>
                        </v-col>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <v-text-field v-model="email"  type="email" label="Email"></v-text-field>
                        </v-col>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <v-text-field v-model="password" type="password" label="Password"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded @click="submit" class="primary">Ingresar</v-btn>
                        </v-col>
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded style="background-color: red;"  @click="volver" >Volver</v-btn>
                        </v-col>

                      </v-row>
                    </v-col>
                    <v-col v-if="registro" lg="8" md="6" cols="12" sm="6">
                      <v-row>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <h2>Registrarse</h2>
                          <v-alert
                              :value="alerterror"
                              color="red"
                              dark
                              dismissible
                              border="top"
                              transition="scale-transition"
                          >
                            {{error }}
                          </v-alert>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" sm="6">
                          <v-text-field v-model="form.nombre"   label="Nombre"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" sm="6">
                          <v-text-field v-model="form.apellidoPaterno"   label="Apellido Paterno"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" sm="6">
                          <v-text-field v-model="form.email"  type="email" label="Email"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" sm="6">
                          <v-text-field v-model="form.telefono" type="number"  label="Telefono"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" sm="6">
                          <v-text-field v-model="password2" type="password" label="Password"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col md="6" lg="6" cols="6" sm="6" >
                          <v-btn rounded @click="register" class="primary">Registrarse</v-btn>
                        </v-col>
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded style="background-color: red;"  @click="volver" >Volver</v-btn>
                        </v-col>
                      </v-row>
                      <v-row>

                      </v-row>
                    </v-col>
                  </v-row>


              </div>
            </v-card-text>

          </v-card></v-col>
        </v-row>

      </v-container>
    </v-main>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";
import firebase from 'firebase/compat/app';
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import {mapGetters} from "vuex";

export default {
  name: "inscripcion",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Inscripción de socios a "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return{
      idnegocio: 0,
      overlay:false,
      alertnuevo:false,
      alertnoacepto:false,
      alerterror:false,
      activePicker:null,
      logoexist: false,
      logoimg: null,
      tokencaptcha:'',
      rese:'',
      browser:false,
      normal:true,
      login:false,
      registro:false,
      boton:false,
      menu: false,
      fechamax:null,
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:{},
        tipoDocumento: {},
        telefono:"",
        direccion:"",
        fechaNacimiento:new Date().toISOString().substr(0, 10),
        sexo:{},
        fotoDni:"",
        postalCode:"",
        distrito:{},
        createdAt:"",
        uidFirebase: "",
        grupoUsuario:{},
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      email: '',
      password:'',
      error:'',
      password2:'',
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
     hayimagen: false,
      imagen:'',
      token:'',
      imagen2:'',
      paises:[],
      provincias:[],
      ciudades:[],
      distritos: [],
      sexos: [{id:0,sexo:"Escoger Sexo"}, {id:1, sexo:"Masculino"}, {id:2, sexo:"Femenino"}],
      tiposdoc: [],
      negocio:[],
      tiposcarnets:[],
      Contactos:[],
      negociodisenio: {
        campoapmaterno: false,
        campodireccion: false,
        campodistrito: false,
        campofecnac: false,
        campofoto: false,
        campoinvitado: false,
        campoizqder: false,
        camporeferido: false,
        camposexo: false,
        campotelefono: false,
        campofumador: false,
        campotipocarnet: false,

        campocontacto: false,
        campocondiciones:false,
        condiciones: '',
      },
      editedItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:''
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
          distrito:'',
          ciudad:{
           id:0,
           ciudad:'',
            provincia:{id:0,
            provincia:'',
            pais:{
              id:0,
              pais:''
            }}
          }},
          createdAt:null,
          uidFirebase:'',
          isprofile:false,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      stylePagina: {
        backgroundColor: 'white',
        color:'white'
      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      }

    }
  }
  ,
  created() {
    if(this.usuario.id>0){
      store.dispatch("conectarse")
      this.editedItem.socioPrincipal = this.usuario
      store.dispatch("conectarse")
    }else{
      store.dispatch("desconectarse")
    }
  },

  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;
    if(this.usuario.id>0){
      store.dispatch("conectarse")
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.editedItem.socioPrincipal = this.usuario
      store.dispatch("conectarse")
    }else{
      store.dispatch("desconectarse")
    }
    this.damenegocio();
    this.damedisenio();
    this.fnBrowserDetect();
    this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
    this.date = this.fechamax
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);

  }
,
watch: {
  date () {
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date)
  },
  menu (val) {
    val && setTimeout(() => (this.activePicker = 'YEAR'))
  },
  '$store.state.usuario': function() {
    this.damepaises();
    this.editedItem.socioPrincipal = this.usuario
  }
},

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },


    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    signinemail(){
      this.normal=false;
      this.login = true;
    },
    registeremail(){
      this.normal = false;
      this.registro = true;
    },
    volver(){
      this.normal = true;
      this.login = false;
      this.registro = false;
    },
    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    cambiopais(){
      this.dameprovincias()
    },
    cambioprovincia(){
      this.dameciudades()
    },
    cambiociudad(){
      this.damedistritos()
    },
    damepaises(){
      this.progr = true;
      axios
          .get('paises',{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.paises = response.data;
            this.cambiopais();
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    submit() {
      this.overlay = true;
      firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(data => {
            this.form.email = this.email;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            this.compruebaemail(data.user)

          })
          .catch(err => {
            if(err.code === "auth/user-not-found"){
              firebase
                  .auth()
                  .createUserWithEmailAndPassword(this.email,this.password)
                  .then((userCredential) =>{
                    const user = userCredential.user;
                    this.form.email = this.email;
                    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                    this.compruebaemail(user)
                  })
              this.overlay = false;
            }else{
              this.error = "Puede haber un error con el email y/o password";
              this.overlay = false;
              this.alerterror = true;
            }
          });
    },
    dameprovincias(){
      this.progr = true;
      axios
          .get('provincias/pais/'+this.editedItem.socioPrincipal.distrito.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.provincias = response.data;
            this.cambioprovincia();

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameContactos(){
      this.progr = true;
      let urlContacto = 'contactos/negocio/' + this.negocio.id ;
      axios
          .get(urlContacto,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Contactos = response.data.filter(function (item){
              return item.activo == true
            });
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/'+this.editedItem.socioPrincipal.distrito.ciudad.provincia.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dametipodocumentos(){
      this.progr = true;
      axios
          .get('tiposdocumento/pais/'+this.negocio.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposdoc = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.editedItem.socioPrincipal.distrito.ciudad.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damenegocio(){
      this.progr = true;

      axios
          .get('negocios/tag/'+this.idnegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.negocio = response.data;
            this.dametipodocumentos();
           this.damecarnetsnegocio();
           this.dameContactos();
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    compruebaemail(user){
      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.form.email)
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            var person = response.data
            if (person.id == null){
              this.registrar(user)
            }else{
              if(person.uidFirebase == null) {
                this.editar(user,person.id)
              }else{
                this.recaptcha(user)
              }
            }
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damecarnetsnegocio(){
      this.progr = true;

      axios
          .get('tipocarnets/negocio/'+this.negocio.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposcarnets = response.data;
              if(this.tiposcarnets.length>1){
                this.negociodisenio.campotipocarnet = true
              }else{
                this.editedItem.tipoCarnetSocio = this.tiposcarnets[0]
              }
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    onFileChange(e) {
      this.imagen2= URL.createObjectURL(this.imagen)
      this.hayimagen = true
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "personas/foto/" + this.usuario.id
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.alerteditar = true
            this.overlay = false
          })
          .catch(error => {
            this.error = error;
            this.overlay = false;
            this.alerterror = true
            console.log(error);
          });
      console.log(e)
    },
    save () {
      if(this.editedItem.aceptoCondicion){
      this.overlay = true;

      var bodyFormData2 = new FormData();

      if (this.editedItem.socioPrincipal.fechaNacimiento === "Fecha inválida"){
        this.editedItem.socioPrincipal.fechaNacimiento = null;
      }else{
        this.editedItem.socioPrincipal.fechaNacimiento = this.formatfechanac(this.editedItem.socioPrincipal.fechaNacimiento)
      }

      bodyFormData2.append("persona",JSON.stringify(this.editedItem.socioPrincipal));
      bodyFormData2.append("tipoCarnetId",this.editedItem.tipoCarnetSocio.id);
      bodyFormData2.append("contacto",JSON.stringify(this.editedItem.contacto));
      bodyFormData2.append("condicion",this.negociodisenio.condiciones);


      axios
          .post('membresia/crear/cortesia',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        let usuariodto = response.data
        console.log(usuariodto);
        this.alertnuevo = true;
        this.overlay = false;
        this.$router.push({ path: '/suscripciones' });
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            console.log(error);
            this.overlay = false;
          });

      }else{
        this.alertnoacepto =true
      }
    },


    estaConectado(){
      this.damepaises();

    },
    async recaptcha(user) {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.tokencaptcha = await this.$recaptcha('inscripcion')
      // Do stuff with the received token.
      if(this.tokencaptcha !=='' ){
        this.logeo(user)
      }

    },
    logeo(user){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append('uuid', user.uid);
      bodyFormData.append('token', this.tokencaptcha);

      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            this.editedItem.socioPrincipal = response.data.persona
            store.dispatch("conectarse");
            this.overlay = false;
            this.estaConectado();
          })
          .catch(error => {
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alerterror = true;
            console.log(error);
          });
    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },

    formatfechanac(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    registrar(user){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            this.editedItem.socioPrincipal = response.data.persona
            store.dispatch("conectarse")
            this.estaConectado();
            this.overlay = false;
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    editar(user,id){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      bodyFormData.append('uidfirebase',this.form.uidFirebase);
      bodyFormData.append("personaId",id)
      axios.post("personas/editafb",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            console.log(response.data);
            this.recaptcha(user)
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    register(){

      this.overlay = true;
      firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email,this.password2)
          .then((userCredential) =>{
            const user = userCredential.user
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            this.compruebaemail(user)
          })
          .catch(error => {
            if(error.code ==="auth/email-already-exists"){
              this.error = "Este email existe en Tunay, se le esta enviando un mail automatico para cambiar de contraseña, luego de cambiarla pruebe con el LOGIN no trate de Registrarse de nuevo";
              this.alerterror = true;
              firebase
                  .auth()
                  .sendPasswordResetEmail(this.form.email);
            }else{

              if(error.code === "auth/email-already-in-use"){
                this.error = "Su Correo existe en nuestra base de datos con Google Mail o Apple Login por favor intente con Registrarse con Google o Registrarse con Apple, tambien puede intentarlo con Login con Google o Login con Apple";
                this.alerterror = true;
                firebase
                    .auth()
                    .sendPasswordResetEmail(this.form.email);
              }else{
                this.error = "Hubo un error con su Conexion";

              }


            }
            this.overlay = false;
            this.alerterror = true;

            console.error(error);
          });
    },
    signingoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    cambiaCheck(){
      if(this.editedItem.aceptoCondicion){
       this.boton = true
      }else{
        this.boton = false
      }
    },
    signinapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
    creategoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    createapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
    damedisenio(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('hasp', this.idnegocio);
      axios
          .post('negociodisenio',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.negociodisenio = response.data;

            if (this.negociodisenio.negocio.logo270 === null){
                this.logoexist = false;
            }else{
              this.logoexist  = true;
              this.logoimg = this.negociodisenio.negocio.logo270;
            }
            if (this.negociodisenio.condiciones !== '' && this.negociodisenio.condiciones !== null){
              this.campocondiciones = true
              this.condiciones = this.negociodisenio.condiciones
              this.editedItem.condicionAceptada = this.condiciones
            }

            this.titulonegocio = this.negociodisenio.negocio.negocio;
            let objPag= {
              backgroundColor: this.negociodisenio.backgroundColor,
              color:this.negociodisenio.colorText
            }
            let btnPag= {
              backgroundColor: this.negociodisenio.colorBgBoton,
              color:this.negociodisenio.colorTxtBoton
            }
            this.btnPag = btnPag
            this.stylePagina = objPag
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      conectado: "conectado"
    })
  }
}
</script>
